import type { Permission } from '@softfactura/shared';

/**
 * Audit RBAC (2026-06-07): rută → permisiunea de READ cerută de API-ul paginii.
 * Folosit de `RoutePermissionGuard` (montat în dashboard layout) ca să blocheze
 * accesul direct (URL/bookmark) pe pagini pe care rolul userului nu le poate citi
 * (altfel pagina se încarcă și dă 403-uri în consolă).
 *
 * Se ia cel mai LUNG prefix care se potrivește (ex. /stocuri/lichidare > /stocuri).
 *
 * EXCLUSE intenționat:
 *  - /facturi: home/fallback universal (guard-ul redirectează AICI) — nu se guardează (buclă).
 *  - Pagini deja cu <RoleRouteGuard> propriu: /contabilitate, /rapoarte,
 *    /transport-alternativ, /achizitii.
 *  - Incerte (de verificat manual): /efactura (cere accounting.read ȘI invoices.read),
 *    /trezorerie (mapare backend ciudată pe efactura.receive), /setari (multi-secțiune).
 */
export const ROUTE_PERMISSIONS: ReadonlyArray<{ prefix: string; permission: Permission }> = [
  { prefix: '/proforme', permission: 'invoices.read' },
  { prefix: '/avize', permission: 'invoices.read' },
  { prefix: '/oferte', permission: 'invoices.read' },
  { prefix: '/facturi-recurente', permission: 'invoices.read' },
  { prefix: '/incasari', permission: 'payments.read' },
  { prefix: '/plati-furnizori', permission: 'payments.read' },
  { prefix: '/clienti', permission: 'clients.read' },
  { prefix: '/furnizori', permission: 'clients.read' },
  { prefix: '/receptie', permission: 'receipts.read' },
  { prefix: '/cheltuieli', permission: 'expenses.read' },
  { prefix: '/borderou-curier', permission: 'couriers.use' },
  { prefix: '/stocuri/lichidare', permission: 'stock.adjust' },
  { prefix: '/stocuri', permission: 'stock.read' },
  { prefix: '/m/scanner', permission: 'stock.adjust' },
  { prefix: '/banca', permission: 'bank_sync.use' },
  { prefix: '/pos', permission: 'pos.use' },
  { prefix: '/trezorerie', permission: 'bank_sync.use' },
  { prefix: '/efactura', permission: 'efactura.receive' },
];
